export default __webpack_public_path__ + "static/media/coupon.a401657a.svg";